module.exports = __webpack_public_path__ + "img/play-market.73d6c891.png";